import { createContext, Dispatch, SetStateAction } from 'react'

export const ResizeContext = createContext<[number?, Dispatch<SetStateAction<number>>?]>([])
